import { BaseService } from './base.service';
import {
  AttachContentPayload,
  ContentAssignment,
  ContentAssignmentPlayerType,
  ListAssignmentsParams,
} from '@/types/contentAssignment';

class ContentAssignmentService extends BaseService {
  constructor() {
    super('/content-library/assignments');
  }

  async listForPlayer(
    playerType: ContentAssignmentPlayerType,
    playerId: string,
    params?: ListAssignmentsParams,
  ): Promise<ContentAssignment[]> {
    const query = new URLSearchParams();
    if (params?.playlistId) query.set('playlistId', params.playlistId);
    if (params?.contentItemId) query.set('contentItemId', params.contentItemId);
    const qs = query.toString();
    return this.get<ContentAssignment[]>(`/${playerType}/${playerId}${qs ? `?${qs}` : ''}`);
  }

  // The API returns an array even for a single content item — attaching a
  // playlist explodes into one ContentAssignment row per item.
  async attachToPlayer(
    playerType: ContentAssignmentPlayerType,
    playerId: string,
    payload: AttachContentPayload,
  ): Promise<ContentAssignment[]> {
    return this.post<ContentAssignment[]>(`/${playerType}/${playerId}`, payload);
  }

  async detach(id: string): Promise<void> {
    return this.delete<void>(`/${id}`);
  }
}

export const contentAssignmentService = new ContentAssignmentService();
